<template>
  <div class="dft-attr_container">
    <h4 class="dft-header">优惠券</h4>
    <!-- 商品 -->
    <div class="attr-item-box" v-for="(item,index) in value" :key="index" :style="{'padding':item.isUse == false?'0':'6px'}">
      <!-- <div class="attr-item-typedata" v-if="item.sid == 'coupon_weapp_s1'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <div class="addImgList">
            <div class="imgList_box">
              <draggable
                tag="div"
                class="cardDrag-list-wrap comp-list"
                v-model="item.value"
                :group="groupRight"
                animation="100"
                delay="10"
                :sort="true"
              >
                <div class="attr-list-item comp-item" v-for="(iitem,iiIndex) in item.value" :key="iitem.id">
                  {{`${iitem.couponType == 1?'代金券':iitem.couponType == 2?'折扣券':iitem.couponType == 3?'满减券':''}: ${iitem.couponName}`}}
                  <i class="el-icon-delete icon_btn" title="删除" @click="mDelete(item.value,iiIndex)"></i>
                </div>
              </draggable>
            </div>
            <div class="upload_btn select_btn" @click="addCoupon(item.value)">
              <i class="el-icon-plus"></i>
              添加优惠券
            </div>
            <addCouponPage
              ref="addCouponPage"
              v-model="item.value"
              :showDialog="showDialog"
              @goBack="goBack"
            ></addCouponPage>
          </div>
        </div>
      </div> -->
      <div class="attr-item-typedata" v-if="item.sid == 'coupon_weapp_s2'">
        <!-- &&value[2].value != '0' -->
        <div class="attr-item-label">
          {{ item.label }}
          <div v-if="item.showList" class="attr-item-on">{{ item.showList[item.value] || item.value }}</div>
        </div>
        <div class="attr-item-value">
          <div class="temp-box">
            <div class="temp-item" :class="item.value == iiIndex?'active_temp-item':''" v-for="(ii,iiIndex) in item.options" :key="iiIndex"
              @click="setActiveListStyle(item, iiIndex)" :style="{cursor:(value[2].value == '6'&&iiIndex == 1 || ['0'].includes(value[2].value)&&[0,1,2].includes(iiIndex))?'not-allowed':'pointer'}">
              <el-image v-if="item.value == iiIndex&&ii.img1" class="temp-item-img" :src="ii.img1" fit="contain"></el-image>
              <el-image v-else-if="ii.img2" class="temp-item-img" :src="ii.img2" fit="contain"></el-image>
              <!-- <div class="temp-item-name"><span class="mini_span">{{ ii.name }}</span></div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="attr-item-typedata" v-else-if="item.sid == 'coupon_weapp_s3'">
        <div class="attr-item-label">
          {{ item.label }}
          <div v-if="item.showList" class="attr-item-on">{{ item.showList[item.value] || item.value }}</div>
        </div>
        <div class="attr-item-value">
          <div class="temp-box">
            <el-radio-group v-model="item.value" size="small" @change="resetAttr(item.value)">
              <el-radio-button :label="iitem.value" v-for="(iitem,ii) in item.optionList" :key="ii">{{iitem.label}}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item.sid == 'coupon_weapp_s4'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div v-if="item.showList" class="attr-item-on">{{ item.showList[item.value] || item.value }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="item.value" size="small">
            <el-radio class="circle-radio" :class="item.value=='#e74c2c'?'circle-radio-sel':''" label="#e74c2c" style="background-color:#e74c2c"></el-radio>
            <el-radio class="circle-radio" :class="item.value=='#ffe9b7'?'circle-radio-sel':''" label="#ffe9b7" style="background-color:#ffe9b7"></el-radio>
            <el-radio class="circle-radio" :disabled="['6','7'].includes(value[2].value)"
              :class="item.value=='#ffffff'?'circle-radio-sel':''" label="#ffffff" :style="{backgroundColor:'#ffffff',cursor:['6','7'].includes(value[2].value)?'not-allowed':'pointer'}"></el-radio>
            <el-radio class="circle-radio" :class="item.value=='#383b3e'?'circle-radio-sel':''" label="#383b3e" style="background-color:#383b3e"></el-radio>
            <el-radio class="circle-radio" :class="item.value=='#e0f4e4'?'circle-radio-sel':''" label="#e0f4e4" style="background-color:#e0f4e4"></el-radio>
          </el-radio-group>
        </div>
      </div>
      <!-- <div class="attr-item-typestyle" style="position: relative;padding-bottom: 25px;" v-else-if="item.sid == 'coupon_weapp_s5'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div v-if="item.showList" class="attr-item-on">{{ item.showList[item.value] || item.value }}</div>
        <div class="attr-item-value">
          <el-checkbox v-model="item.value" true-label="1" false-label="2"></el-checkbox>
        </div>
        <div class="info-set">当页面无可显示的优惠券时，优惠券区块将隐藏</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import addCouponPage from './addCouponPage.vue'
export default {
  components: {
    draggable,
    addCouponPage
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  data () {
    return {
      showDialog: false,
      groupRight: {
        name: 'itxst2',
        pull: false, // 拖出
        put: false // 拖入
      },
      // 模板默认数据 4
      assemblyAttr666: JSON.stringify(
        [
          {
            label: '添加优惠券', value: [], key: 'couponList', type: 'data', tag: 'multiple-select', sid: 'coupon_weapp_s1'
          }, // 0
          {
            label: '排列样式',
            value: 3,
            key: 'listStyle',
            type: 'data',
            tag: '',
            sid: 'coupon_weapp_s2',
            showList: {
              0: '大图模式',
              1: '一行两个',
              2: '一行三个',
              3: '横向滑动'
            },
            options: [
              { name: '大图模式', img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png' },
              { name: '一行两个', img1: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FluleLjR6gMJ9p_H9P5WEAhgPa8d.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FkdiKOW0JN9yIoDhGRXaeJQ6H8TJ.png' },
              { name: '一行三个', img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png' },
              { name: '横向滑动', img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png' }
            ]
          }, // 1
          {
            label: '卡片样式',
            value: '0',
            key: 'goodsStyle',
            type: 'data',
            tag: '',
            sid: 'coupon_weapp_s3',
            showList: {
              '0': '首页样式',
              '1': '样式一',
              '2': '样式二',
              '3': '样式三',
              '4': '样式四',
              '5': '样式五',
              '6': '样式六',
              '7': '样式七',
              '8': '样式八'
            },
            optionList: [
              { 'label': '首页样式', 'value': '0' },
              { 'label': '样式一', 'value': '1' },
              { 'label': '样式二', 'value': '2' },
              { 'label': '样式三', 'value': '3' },
              { 'label': '样式四', 'value': '4' },
              { 'label': '样式五', 'value': '5' },
              { 'label': '样式六', 'value': '6' },
              { 'label': '样式七', 'value': '7' },
              { 'label': '样式八', 'value': '8' }
            ]
          }, // 2
          {
            label: '颜色',
            value: '#ffffff',
            sid: 'coupon_weapp_s4',
            showList: {
              '#e74c2c': '红色',
              '#ffe9b7': '黄色',
              '#ffffff': '白色',
              '#383b3e': '黑色',
              '#e0f4e4': '绿色'
            },
            key: 'background-color',
            type: 'style',
            tag: 'radio'
          }, // 3
          {
            label: '隐藏已抢完及失效的券',
            value: '1',
            sid: 'coupon_weapp_s5',
            showList: {
              '1': '隐藏',
              '2': '不隐藏'
            },
            key: 'ishidden',
            type: 'style',
            tag: 'checkbox'
          }// 4
        ]
      )
    }
  },
  watch: {
    // value: {
    //   handler: function(newVal){
    //     if(newVal){
    //       this.$nextTick(() => {
    //         // console.log('comp--D-ata',newVal)
    //       });

    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {

  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    },
    addCoupon (list) {
      this.showDialog = true
    },
    setActiveListStyle (item, iiIndex) {
      if (this.value[2].value == '6' && iiIndex == 1 || ['0'].includes(this.value[2].value) && [0, 1, 2].includes(iiIndex)) { return }
      item.value = iiIndex
    },
    resetAttr (val) {
      if (val == '0') {
        this.value[1].value = 3
      }
      if (['6', '7'].includes(val) && this.value[3].value == '#ffffff') {
        this.value[3].value = '#e74c2c'
      }
      if (val == '6' && this.value[1].value == 1) {
        this.value[1].value = 3
      }
    },
    // 删除
    mDelete (value, iiIndex) {
      value.splice(iiIndex, 1)
    },
    goBack (val) {
      // this.$refs.addCouponPage.dialogVisible = false
      // console.log('l;l;',val)
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-attr_container{
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
}
.dft-header{
  margin: 1px 0;
}
.attr-item-box{
  padding: 6px 6px;
  .attr-item-typedata{
    margin-bottom: 10px;
    .attr-item-label{
      margin-bottom: 5px;
      font-size: 14px;
      color: #969799;
      .attr-item-on{
        display: inline-block;
        margin-left: 15px;
        color: #333333;
        font-size: 15px;
      }
    }
    .attr-item-value{
      .temp-box{
        display: flex;
        flex-wrap: wrap;
        .temp-item{
          width: calc((100% - 36px)/6);
          height: 60px;
          margin: 0 3px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .temp-item-img{
            width: 48px;
            height: 48px;
            margin-bottom: 8px;
          }
          .temp-item-name{
            font-weight: 400;
            font-size: 11px;
            line-height: 20px;
            text-align: center;
            color: #333;
            .mini_span{
              // transform: scale(.7);
            }
          }
        }
        .active_temp-item{
          .temp-item-name{
            color: #155bd4;
          }
        }
      }
      .addImgList{
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        background-color: #f7f8fa;
        padding: 10px 12px;
        box-sizing: border-box;
        .img_info{
          color: #969799;
          font-weight: 400;
          margin-top: 8px;
          white-space: pre-wrap;
          font-size: 13px;
        }
        .imgList_box{
          // padding: 12px 0;
          width: 100%;
          box-sizing: border-box;
          .imgList-item{
            border: 1px solid #e0e0e0;
            margin: 12px 0;
            padding: 4px;
            box-sizing: border-box;
            display: flex;
            .ii-img-box{
              width: 80px;
              height: 100px;
              position: relative;
              .ii-img{
                width: 100%;
                height: 100%;
              }
              .ii-img-btn{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 20px;
                background-color: rgba($color: #000000, $alpha: .5);
                text-align: center;
                font-size: 13px;
                color: #ffffff;
                cursor: pointer;
              }
            }
            .ii-link-box{
              width: calc(100% - 80px);
              box-sizing: border-box;
              height: 100px;
              padding: 0 8px;
              .ii-link-info{
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #999;
              }
              .ii-link{}
            }
          }
        }

        .upload_btn{
          background: #efefef;
          border-radius: 2px;
          padding: 6px 10px 6px 14px;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          width: fit-content;
          margin: 0 auto;
          color: #333;
          cursor: pointer;
        }
        .comp-item{
          width: 100%;
          margin: 8px 0 0;
          padding: 6px 10px 6px 14px;
          box-sizing: border-box;
          background-color: #fff;
          border-radius: 2px;
          display: flex;
          align-items: center;
          border-radius: 2px;
          background-color: #fff;
          box-shadow: 0 0 4px 0 rgba(10, 42, 97, .2);
          cursor: grab;
          position: relative;
          .icon_btn{
            position: absolute;
            top: 8px;
            right: 16px;
            font-size: 16px;
            cursor: pointer;
            display: none;
          }
          &:hover{
            .icon_btn{
              display: block;
            }
          }
        }
        .select_btn{
          width: 100%;
          margin: 8px 0 0;
          box-sizing: border-box;
          background-color: #fff;
          border: 1px solid #155bd4;
          border-radius: 2px;
          color: #155bd4;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .attr-item-typestyle{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;
    .attr-item-label{
      color: #969799;
      // color: #333333;
      margin-right: 12px;
    }
    .attr-item-on{
      color: #333333;
      margin-right: 8px;
      font-size: 12px;
    }
    .attr-item-value{
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

}

.colorPicker{
  height: 40px;
  display: flex;
  align-items: center;
}
.custon_slider{
  width: 100%;
  /deep/.el-slider__input{
    width: 60px;
  }
  /deep/.el-slider__runway.show-input{
    margin-left: 8px;
    margin-right: 80px;
  }
}
.btn-icon{
  line-height: 20px;
  color: #f44;
}
.select-option{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.select-btn{
  height: 18px;
  padding: 0 8px;
}
.info-set{
  position: absolute;
  bottom: 0;
  left: 0;
  color: #969799;
  font-size: 12px;
}
.circle-radio{
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 8px;
  /deep/.el-radio__input,/deep/.el-radio__label{
    display: none;
  }
  cursor: pointer;
}
.circle-radio-sel{
  border: 1px solid #155bd4;
  box-shadow: inset 0 0 1px 2px #fff;
}
</style>
